import {gql} from '@apollo/client';

import * as ObservationFragments from 'web-app/react/entities/observations/fragments';

export const CreateObservation = gql`
    mutation createObservation(
        $observationId: ObservationId
        $childIds: [ChildId!]
        $remark: ChildDevelopmentRemarkInput!
        $nextStep: ChildDevelopmentRemarkInput
        $status: ObservationStatusState!
        $fileIds: [FileId!]
        $imageIds: [ImageId!]
        $videoId: VideoId
        $variant: ObservationVariant
        $version: ObservationVersion
        $settings: ObservationSettingsInput
    ) {
        childDevelopment {
            observations {
                createObservation(
                    observationId: $observationId
                    childIds: $childIds
                    remark: $remark
                    nextStep: $nextStep
                    status: $status
                    fileIds: $fileIds
                    imageIds: $imageIds
                    videoId: $videoId
                    variant: $variant
                    version: $version
                    settings: $settings
                ) {
                    __typename
                    ...ObservationData
                }
            }
        }
    }
    ${ObservationFragments.ObservationData}
`;

export const DeleteObservation = gql`
    mutation deleteObservation($observationIds: [ObservationId!]!) {
        childDevelopment {
            observations {
                deleteObservations(observationIds: $observationIds)
            }
        }
    }
`;

export const Observations = gql`
    query Observations(
        $authors: [LoginId!]
        $statuses: [ObservationStatusState!]
        $childIds: [ChildId!]
        $variants: [ObservationVariant!]
    ) {
        childDevelopment {
            observations(
                authors: $authors
                first: 1000
                statuses: $statuses
                childIds: $childIds
                variants: $variants
            ) {
                results {
                    ...ObservationData
                }
            }
        }
    }
    ${ObservationFragments.ObservationData}
`;
